<template>
  <div class="contact">
    <div class="header">
      <h5>Contact us</h5>
      <a href="/">
      <span class="back">
        <img src="../../assets/images/back.png">
      </span>
      </a>
    </div>
    <div class="inner">
      <p>
        Facebook: 
        <br/>
        <a href="//www.facebook.com/Card-Times-106853314872185" target="_blank">www.facebook.com/Card-Times-106853314872185</a>
      </p>
    </div>
    <div class="foot">
      <div class="section">
        <div class="list">
          <h5>Cardpedia</h5>
          <a href="about.html"><p>About us</p></a>
          <a href="contact.html"><p>Contact us</p></a>
          <a href="business.html"><p>Business</p></a>
        </div>
        <div class="list">
          <h5>{{footNav1.englishName}}</h5>
          <p 
            v-for="(item, index) in footNav1.blogList" 
            :key="index">
            <a :href="item.urlH5">
              {{item.artTitle}}
            </a>
          </p>
        </div>
      </div>
      <div class="section" 
        v-for="item in footNav2" 
        :key="item.id">
        <div class="list">
          <h5>{{item.englishName}}</h5>
          <p 
            v-for="(items, index) in item.blogList" 
            :key="index">
            <a :href="items.urlH5">
              {{items.artTitle}}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components:{

  },
  data () {
    return {
      footNav1:{},
      footNav2:[],
    }
  },
  computed:{

  },
  methods:{
    async getHost(url){
      if(url.indexOf('test') != -1){
        //测试
        return `//${url.replace('h5test.', 'pctest.')}/blog`
      }else{
        //正式
        return `//${url.replace('h5.', '')}/blog`
      }
    },
    //获取底部导航
    async getFootNav(){
      const res = await this.$api.home.getFootNav({
        params:{
          subsidiaryCode: 'blog000000001',
        }
      })
      let url = await this.getHost(window.location.host)
      for(let i=0; i<res.length; i++){
        for(let j=0; j<res[i].blogList.length; j++){
          res[i].blogList[j].urlH5 = `${url}/${res[i].blogList[j].urlH5}`
        }
      }
      this.footNav1 = res[0]
      this.footNav2 = res.slice(1)
    }
  },
  created(){
    //获取底部导航
    this.getFootNav()
  },
  mounted(){

  },
  watch:{

  }
}
</script>

<style lang="less" scoped>
.contact{
  .header{
    padding: 15px 0;
    position: relative;
    border-bottom: 1px solid #e2e2e2;
    h5{
      font-size: 17px;
      font-weight: 600;
      color: #333333;
      text-align: center;
    }
    span{
      position: absolute;
      top: 12px;
      left: 15px;
      img{
        width: 26px;
      }
    }
  }
  .inner{
    padding: 25px 15px;
    min-height: 150px;
    h5{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 20px;
    }
    p{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 15px;
      line-height: 20px;
    }
    p:last-child{
      margin-bottom: 0;
    }
  }
  .foot{
    background: #E2EAFB;
    padding: 15px;
    .section{
      display: flex;
      margin-top: 20px;
      .list{
        h5{
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 20px;
        }
        p{
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 15px;
          a{
            color: #666666;
          }
        }
      }
      .list:first-child{
        margin-right: 60px;
      }
    }
  }
}
</style>
